export const defs = {
    sortable: false,
    floatingFilter: false,
    autoHeight: true,
    flex: 1,
};